export default __webpack_public_path__ + "static/media/10.ff11490c.jpg";